import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const getOneMonthFromToday = () => {
    const date = new Date(); // today
    date.setMonth(date.getMonth()+1);
    return date;
}

export default () => {
    const cookieName = 'hide-safari-tab-tip'

    const [cookies, setCookie] = useCookies([cookieName]);
    const cookieVal = (cookies[cookieName] === 'true');
    const [show, setShow] = useState(!cookieVal);
    
    const closeDialog = () => {
        setShow(false);
    }

    const closeWithCookie = () => {
        const expires = getOneMonthFromToday();
        setCookie(cookieName, true, { expires });
        setShow(false);
    }

    return (
        <Dialog
            open={show}
            onBackdropClick={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Tip for Safari Users"}</DialogTitle>
            <DialogContent>
                <DialogContentText paragraph id="alert-dialog-description">
                    To enter data as quickly as possible, we recommend pressing "tab" to switch between inputs. However,
                    on Safari you must enable a setting in your browser preferences to enable you to tab from the last input to
                    the buttons at the end of the row (c'mon Apple). 
                </DialogContentText>
                <DialogContentText paragraph id="alert-dialog-description">
                    To do this, make sure to check the checkbox located in the path specified below:
                </DialogContentText>
                <DialogContentText paragraph fontWeight={600} id="alert-dialog-description">
                    <strong>Preferences > Advanced > "Press Tab to highlight each item on a webpage"</strong>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    variant='contained'
                    color='primary'
                    onClick={closeWithCookie}
                >
                    Don't show this alert again
                </Button>
                <Button 
                    variant='contained'
                    color='primary'
                    onClick={closeDialog}
                >
                    Remind Me Later
                </Button>
            </DialogActions>
        </Dialog>
    )
}